import api from './api';

const getAllLaporan = () => { 
    return api.get("/laporan/all"); 
};

// Modifikasi untuk mengambil data laporan menggunakan UUID anonim browser pelapor
const getLaporanBySessionId = (sessionId) => { 
    return api.get(`/laporan/session/${sessionId}`); 
};

const createLaporan = (formData) => {
    return api.post("/laporan/create", formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

const prosesLaporan = (laporanId, feedbackData) => {
    let formData;
    if (feedbackData instanceof FormData) {
        formData = feedbackData;
    } else {
        formData = new FormData();
        formData.append('feedbackDeskripsi', feedbackData.feedbackDeskripsi);
        formData.append('status', feedbackData.status);
        if (feedbackData.feedbackDokumen) {
            formData.append('feedbackDokumen', feedbackData.feedbackDokumen);
        }
    }
    return api.put(`/laporan/proses/${laporanId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

const laporanService = { 
    getAllLaporan, 
    getLaporanBySessionId,
    createLaporan, 
    prosesLaporan 
};

export default laporanService;